import { render, staticRenderFns } from "./ModalVerAnotacoes.vue?vue&type=template&id=43b6de72&scoped=true&"
import script from "./ModalVerAnotacoes.vue?vue&type=script&lang=js&"
export * from "./ModalVerAnotacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b6de72",
  null
  
)

export default component.exports